import { render, staticRenderFns } from "./ModalContribution.vue?vue&type=template&id=633b4ea4&"
import script from "./ModalContribution.vue?vue&type=script&lang=js&"
export * from "./ModalContribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports